import React from "react";
import { Button, Col, Grid, Image, Row } from "antd";
import { RiMenuFill } from "react-icons/ri";
import HeaderUser from "./HeaderUser";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import logo  from "../../../assets/images/logo/chetna2.png";
const { useBreakpoint } = Grid;

const MenuHeader = ({ setVisible }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  return (
    <Row  
      align="middle"
      justify="space-between"
      style={{ width: "100%", height: "64px", padding: "0 24px" }}
    >
      {/* Left: Mobile Menu Button */}
      <Col>
        {isMobile ? (
          <Button
            type="text"
            onClick={() => setVisible(true)}
            icon={<RiMenuFill size={24} style={{ color: "#34656D" }} />}
          />
        ) : (
          <div />
        )}
      </Col>

      {/* Center: (Optional logo/title here) */}
      <Col flex="auto">
       <Image src={logo} width={75} height={75} preview={false}/>
      </Col>
      {/* Right: Menu items + user profile */}
      <Col>
        <Row align="middle" gutter={32}>
          {/* Menu items */}
          <Col>
            {/* <Row align="middle" gutter={24}>
              <Col>
                <Link to="/dashbaord" className="header-menu-item">
                  Dashboard
                </Link>
              </Col>
              <Col>
                <Link to="/patientlist" className="header-menu-item">
                  Patient List
                </Link>
              </Col>
             
            </Row> */}
          </Col>

          {/* User Profile */}
          <Col>
            <HeaderUser />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default MenuHeader;
